/**
 * Wire-format surface for the CampaignsWell GA4 events.
 *
 * Event names, param keys and param *values* are CampaignsWell's, not ours —
 * exposed here so the dispatcher writes `params[CW_PARAM_KEY_SUBSCRIPTION_ID]`
 * instead of free-form literals (no snake_case leaks out of this file).
 *
 * No GA4 custom dimension registration is needed: CampaignsWell confirmed
 * their connector parses raw event params directly.
 */

export const CampaignswellEvent = {
  /** Initial paid conversion — a subscription activation. */
  SUBSCRIBE: "cw_subscribe",
  /** Non-recurring ("nrc") purchase. See `campaignswellEventMap.ts`. */
  NRC_PURCHASE: "cw_nrc_purchase",
} as const;
export type CampaignswellEvent = (typeof CampaignswellEvent)[keyof typeof CampaignswellEvent];

export const CW_PARAM_KEY_SUBSCRIPTION_ID = "subscription_id";
export const CW_PARAM_KEY_TRANSACTION_ID = "transaction_id";
export const CW_PARAM_KEY_PAYMENT_SYSTEM = "payment_system";
export const CW_PARAM_KEY_PRODUCT_ID = "product_id";
export const CW_PARAM_KEY_CURRENCY = "currency";
/** The billing platform's customer id (Sticky's), not our user id. */
export const CW_PARAM_KEY_CUSTOMER_ID = "customer_id";
/** Our internal user id — must match the `user_id` on the CATTRNX postback. */
export const CW_PARAM_KEY_CLIENT_USER_ID = "cw_client_user_id";
/** CampaignsWell calls this `price`; our internal params call it `value`. */
export const CW_PARAM_KEY_PRICE = "price";

export type CampaignswellWireParams = Record<string, unknown>;
